import { GetUserDataDashboard } from 'domain/usecases/dashboard/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetUserDataDashboard implements GetUserDataDashboard {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetUserDataDashboard.Model>;

  constructor(url: string, httClient: HttpClient<GetUserDataDashboard.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  getUserData = async (
    params: GetUserDataDashboard.Params,
  ): Promise<GetUserDataDashboard.Model> => {
    let query = '';
    if (params.query) {
      query = '?';
      Object.entries(params.query).forEach(([key, value]) => {
        query += `${key}=${value}&`;
      });
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url}${query}`,
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
